import React, { useEffect, useState } from "react";
import styles from "../../../assets/css/admin/layout.module.css"
import "../../../assets/css/admin/allAdmins.module.css"
import SideBar from "../SideBar";
import axios from "axios";
import { baseUrl } from "../../../baseUrl";
import swal from "sweetalert";
import { Link } from "react-router-dom";
import moment from "moment/moment";
import {useAuth} from "../../../AuthContext"
import { useSidebar } from "../../../context/SidebarContext";
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import CloneExamModal from "./CloneExamModal";
import ContentCopyTwoToneIcon from '@mui/icons-material/ContentCopyTwoTone';
import EditIcon from '@mui/icons-material/Edit';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { Hourglass } from 'react-loader-spinner';
import api from "../../../api";

const AllExam = () => {
  const { logout, user } = useAuth();
  const { isSidebarOpen, toggleSidebar } = useSidebar();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [allExams, setAllExams] = useState([]);
  const [examsLoading,setExamsLoading] = useState(false);
  const [courses, setCourses] = useState([]);
  const [filteredExams, setFilteredExams] = useState([]);
  const [classFilter, setClassFilter] = useState(localStorage.getItem('all-exams-class') || '');
  const [courseFilter, setCourseFilter] = useState(localStorage.getItem('all-exams-course') || '');
  const [statusFilter, setStatusFilter] = useState("");
  const [deleting,setDeleting]=useState(false)

  const getExams=()=>{
    setExamsLoading(true)
    axios.get(`${baseUrl}/exam/course/${courseFilter}`)
      .then(res => {
        setAllExams(res.data.exams); // Store all exams in the state
        setFilteredExams(res.data.exams);
        setExamsLoading(false)
      })
      .catch((e) => {
        console.log(e);
        setExamsLoading(false);
      });
  }
  const getCourses = () => {
    axios.get(`${baseUrl}/course/by-class?className=${classFilter}`)
      .then(res => setCourses(res.data))
      .catch(err => console.log(err))
  }
  const handleCourseChange = (e) => {
    setFilteredExams([])
    const selectedCourseID = e.target.value;
    localStorage.setItem("all-exams-course", selectedCourseID);
    setCourseFilter(selectedCourseID);
  };

  const handleClassChange = (e) =>{
    localStorage.setItem("all-exams-class",e.target.value)
    setClassFilter(e.target.value)
  }
  useEffect(()=>{
    getExams()
  },[courseFilter])
  useEffect(() => {
    setFilteredExams([])
    getCourses();
  }, [classFilter])
  const filterExams = () => {
    let filtered = [...allExams]; // Start with all exams
    if (statusFilter) {
      filtered = filtered.filter((exam) => {
        if (statusFilter === "active") {
          return moment(exam.endDate).isAfter(moment()); // Exam is active if its endDate is after the current date
        } else if (statusFilter === "inactive") {
          return moment(exam.endDate).isBefore(moment()); // Exam is inactive if its endDate is before the current date
        }
        return true; // No filter for status
      });
    }

    setFilteredExams(filtered); // Update filtered exams based on the applied filters
  };
  useEffect(() => {
    filterExams(); // Apply filters whenever any filter value changes
  }, [statusFilter]);
  const deleteExam=(a)=>{
    swal({
        title: "Are you sure?",
        text: "Deleting exam will also delete questions associated with this exam. Once deleted, you will not be able to recover!",
        icon: "warning",
        buttons: true,
        dangerMode: true,
      })
      .then((willDelete) => {
        if (willDelete) {
          setDeleting(true)
          api
          .post(`${baseUrl}/exam/delete/?id=${a._id}`)
            .then(res=>{
              getExams()
                swal("Exam and questions has been deleted!", {
                    icon: "success",
                  });
                setDeleting(false)
                }
            )
            .catch(err=>{
              setDeleting(false)
              swal(err?.response?.data?.message || "Something went wrong",{icon:'error'})
            })
          
        } 
      });
}
  function convertMinutesToHM(minutes) {
    const hours = Math.floor(minutes / 60); // Get the whole hours
    const mins = minutes % 60; // Get the remaining minutes

    return `${hours} hr${hours !== 1 ? 's' : ''} ${mins>0?`${mins} min${mins !== 1&&mins!==0 ? 's' : ''}`:''}`;
  }
  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };
  return (
    <div className={`${styles.layout} ${isSidebarOpen ? '' : `${styles.sidebarClosed}`}`}>
      <aside className={`${styles.sidebar} ${isSidebarOpen ? `${styles.open}` : `${styles.closed}`}`}>
        <SideBar />
      </aside>

      <main className={styles.mainContent}>
        {deleting && (
          <div className="loading-overlay">
            <Hourglass
              visible={true}
              height="80"
              width="80"
              ariaLabel="hourglass-loading"
              wrapperStyle={{}}
              wrapperClass=""
              colors={['#306cce', '#72a1ed']}
            />
          </div>
        )}

        <div style={{ height: '30px' }} className="position-relative">{isSidebarOpen ? <CloseIcon className={`position-absolute end-0 ${styles.ham}`} onClick={toggleSidebar} /> : <MenuIcon className={`position-absolute end-0 ${styles.ham}`} onClick={toggleSidebar} />}</div>
                <nav aria-label="breadcrumb" >
                  <ol className="breadcrumb">
                    <div className="d-flex flex-grow-1">
                    <li className="breadcrumb-item">
                      <Link to='/admin/dashboard' className="text-decoration-none">Dashboard</Link>
                    </li>
                    <li className="breadcrumb-item active">
                        All Exams
                    </li>
                    <li className="breadcrumb-item">
                      <Link to='/admin/exams/create' className="text-decoration-none">Create</Link>
                    </li>
                    </div>
                    <li className="nav-item dropdown">
                    <span
                      className="nav-link dropdown-toggle"
                      data-bs-toggle="dropdown"
                      href=""
                      role="button"
                      aria-expanded="false"
                    >
                      Welcome, {user.name}
                      <i className="ml-2 fa fa-angle-down"></i>
                    </span>
                    <ul className="dropdown-menu" style={{minWidth:'150px'}}>
                      <li>
                        <span className="dropdown-item" onClick={logout}>
                          Logout
                        </span>
                      </li>
                    </ul>
                  </li>
                  </ol>
                </nav>
        <div
          className="container-fluid"
          style={{ backgroundColor: "white", padding: "40px" }}
        >
          <div className="d-flex">
            <h4 className="mb-4 mr-3"> All Exams</h4>
            <button onClick={openModal} className="btn btn-info btn-sm p-2 h-50">
              Clone Exam <ContentCopyTwoToneIcon fontSize="small" />
            </button>
          </div>

          <div className="filters mb-4 d-flex flex-wrap gap-3">
            <div className="filter-item">
              <label htmlFor="classFilter" className="form-label">Class</label>
              <select
                id="classFilter"
                className="form-select"
                value={classFilter}
                onChange={handleClassChange}
              >
                <option value="" hidden>Select Class</option>
                <option value="Class XI">Class XI</option>
                <option value="Class XII">Class XII</option>
                <option value="Class XII Passed">Class XII Passed</option>
              </select>
            </div>
            <div className="filter-item">
              <label htmlFor="courseFilter" className="form-label">Course</label>
              <select
                id="courseFilter"
                className="form-select"
                value={courseFilter}
                onChange={handleCourseChange}
              >
                <option value="" hidden>Select Course</option>
                {
                  courses.map((c,i)=>
                  <option key={i} value={c.courseID}>{`${c.title}`}</option>)
                }
              </select>
            </div>

            <div className="filter-item">
              <label htmlFor="statusFilter" className="form-label">Status</label>
              <select
                id="statusFilter"
                className="form-select"
                value={statusFilter}
                onChange={(e) => setStatusFilter(e.target.value)}
              >
                <option value="">both</option>
                <option value="active">Active</option>
                <option value="inactive">Inactive</option>
              </select>
            </div>

            {/* Modal Component */}
            <CloneExamModal isOpen={isModalOpen} closeModal={closeModal} />
          </div>

          <div style={{overflowX:'scroll'}}>
            <table>
              <thead>
                <tr>
                  <td>No.</td>
                  <td>Exam ID</td>
                  <td style={{minWidth:'150px'}}>Exam Name</td>
                  <td style={{minWidth:'121px'}}>Time</td>
                  <td style={{minWidth:'117px'}}>Start Date</td>
                  <td style={{minWidth:'117px'}}>End Date</td>
                  <td>Attempts</td>
                  <td style={{minWidth:'335px'}} className="text-center">Actions</td>
                </tr>
              </thead>
              <tbody>
                {
                  examsLoading && <><br /><img src="/assets/images/load-time.gif" width='50px' alt="loading" /></>
                }
                {
                  !examsLoading&&filteredExams.length<1&&
                  <tr>
                    <td colSpan={5}>No exams found</td>
                  </tr>
                }
                {filteredExams.length > 0 &&
                  filteredExams.map((a, i) => (
                    <tr key={i}>
                      <td>{i+1}</td>
                      <td>{a._id}</td>
                      <td>{a.examName}</td>
                      <td>{convertMinutesToHM(a.timeLimit)}</td>
                      <td>{moment(a.startDate).format('D MMM YYYY')}</td>
                      <td>{moment(a.endDate).format('D MMM YYYY')}</td>
                      <td>{a.attempts}</td>
                      <td>
                        <Link to={`/exam/edit/${a._id}`}><button className="btn btn-success btn-sm m-1 p-1"
                          data-bs-toggle="tooltip"
                          data-bs-placement="top"
                          title="View Exam"><EditIcon fontSize="small" /></button></Link>&nbsp;
                        <Link to={`/admin/exam/question-paper/${a._id}`}><button className="btn btn-info btn-sm m-1 p-1">Paper</button></Link>&nbsp;
                        <Link to={`/admin/exam/solution/${a._id}`}><button className="btn btn-warning btn-sm m-1 p-1">Solution</button></Link>&nbsp;
                        {
                          a.course.type === 'TPT' ?
                            <Link to={`/exam/tpt/result/${a._id}`}><button className="btn btn-success btn-sm m-1 p-1">Result&nbsp;</button></Link> :
                            <Link to={`/exam/result/${a._id}`}><button className="btn btn-success btn-sm m-1 p-1">Result&nbsp;</button></Link>
                        }
                        <button disabled={deleting} onClick={()=>deleteExam(a)} className="btn btn-danger btn-sm m-1 p-1"
                          data-bs-toggle="tooltip"
                          data-bs-placement="top"
                          title="Delete Exam"><DeleteOutlineIcon fontSize="small"/></button>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        </div>
      </main>
    </div>
  );
};

export default AllExam;
